import { register } from '|>/shared/vjs'
import { BaseMenu } from '../../../base'
import { LocalEvents } from '../../local-events'
import { SettingsBackTitle } from '../../settings-back-title'

/**
 * Interface for any component that can trigger events
 */
interface IEventContainer {
  trigger(event: string, data?: any): void
  requestAnimationFrame(fn: () => void): void
  el_?: HTMLElement
}

/**
 * Factory function to create custom subtitle menu classes
 */
export function createSubtitlesCustomMenu(
  className: string,
  title: string,
  getMenuItems: () => any[]
) {
  @register
  class CustomMenu extends BaseMenu {
    declare container: IEventContainer | undefined
    declare backTitle: SettingsBackTitle

    constructor(player: any, options: any) {
      super(player, options)

      // Set parent menu reference for all items (except backTitle)
      this.children_.forEach((child: any) => {
        if (child !== this.backTitle) {
          child.parentMenu = this
        }
      })
    }

    update() {
      this.backTitle.container = this.container

      // Update all menu items to reflect current settings
      this.children_.forEach((child: any) => {
        if (child.update && child !== this.backTitle) {
          child.update()
        }
      })
    }

    activate() {
      this.addClass('vjs-x-active')

      // Update items when menu is activated to show current selection
      this.update()
    }

    deactivate() {
      this.removeClass('vjs-x-active')
    }
  }

  Object.defineProperty(CustomMenu, 'name', { value: className })

  CustomMenu.options = {
    className: 'vjs-x-settings-main-menu vjs-menu',
    children: [
      SettingsBackTitle.as('backTitle', {
        backEvent: LocalEvents.SettingsActivateSubtitlesCustomMenu,
        title,
      }),
      ...getMenuItems(),
    ],
  }

  return CustomMenu
}
